import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item', 'content']
  static classes = ['active', 'inactive']

  connect() {
    // Add click handlers to all buttons
    this.element
      .querySelectorAll('button[data-accordion-target]')
      .forEach((button) => {
        button.addEventListener('click', this.toggle.bind(this))
      })
  }

  toggle(event) {
    const button = event.currentTarget
    const contentId = button.getAttribute('data-accordion-target')
    const content = this.element.querySelector(contentId)
    const icon = button.querySelector('svg[data-accordion-icon]')

    if (content.classList.contains('tw-hidden')) {
      content.classList.remove('tw-hidden')
      icon.classList.add('rotate-180')
      button.classList.remove(this.inactiveClass)
      button.classList.add(this.activeClass)
      button.setAttribute('aria-expanded', 'true')
    } else {
      content.classList.add('tw-hidden')
      icon.classList.remove('rotate-180')
      button.classList.remove(this.activeClass)
      button.classList.add(this.inactiveClass)
      button.setAttribute('aria-expanded', 'false')
    }
  }
}
